import { fromEnv } from "src/helpers";

export const ONEDASHBOARD_BASE_URL = fromEnv<string>("REACT_APP_ONEDASHBOARD_BASE_URL");
export const DASHBOARD_BASE_URL = fromEnv<string>("REACT_APP_DASHBOARD_BASE_URL");
export const DASHBOARD_BETA_BASE_URL = fromEnv<string>(
  "REACT_APP_DASHBOARD_BETA_BASE_URL"
);

export const HERA_BASE_URL = DASHBOARD_BASE_URL;
export const SDK_BASE_URL =
  String(fromEnv<string>("REACT_APP_IS_STAGGERED_ROLLOUT")) === "true"
    ? DASHBOARD_BETA_BASE_URL
    : DASHBOARD_BASE_URL;
